/**
 * The with of the client at witch the facial expressions will be reduced to only 4.
 */
export const REDUCE_EXPRESSIONS_THRESHOLD = 750;

export const SPEAKER_STATS_RELOAD_INTERVAL = 1000;
